import { useState } from 'react';
import { toast } from 'react-hot-toast';
import DialogShell from '../../components/DialogShell';
import { approveDeposit } from '../../services';

function getErrorMessage(error) {
  return error.response?.data?.error || error.response?.data?.message || error.message || 'Request failed';
}

export default function ApproveDepositDialog({ deposit, onClose, onApproved }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleConfirm() {
    setIsSubmitting(true);
    try {
      const result = await approveDeposit(deposit.id);
      toast.success('Đã duyệt deposit thành công.');
      onApproved(result);
    } catch (error) {
      toast.error(getErrorMessage(error));
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <DialogShell onClose={onClose}>
      <h4 className="text-lg font-semibold text-slate-900">Duyệt deposit #{deposit.id}</h4>
      <div className="mt-3 space-y-1 text-sm text-slate-600">
        <p>User: <span className="font-medium text-slate-900">{deposit.username}</span></p>
        <p>Số tiền quy đổi (USD): <span className="font-medium text-slate-900">{deposit.received_amount?.toLocaleString('vi-VN', { minimumFractionDigits: 2 })}</span></p>
        <p>Phương thức: <span className="font-medium text-slate-900">{deposit.method_callback}</span></p>
      </div>
      <p className="mt-3 rounded-lg bg-amber-50 px-3 py-2 text-xs text-amber-800">
        Sau khi duyệt, số dư của user sẽ được cộng thêm {deposit.received_amount?.toLocaleString('vi-VN', { minimumFractionDigits: 2 })} USD. Hành động này không thể hoàn tác.
      </p>
      <div className="mt-5 flex justify-end gap-2">
        <button type="button" onClick={onClose} className="rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-700">
          Hủy
        </button>
        <button
          type="button"
          onClick={handleConfirm}
          disabled={isSubmitting}
          className="rounded-lg bg-cyan-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-60"
        >
          {isSubmitting ? 'Đang duyệt...' : 'Xác nhận duyệt'}
        </button>
      </div>
    </DialogShell>
  );
}
